import { Container, type ContainerProps } from '@mui/material';

const pageSx = {
  width: 1,
  minWidth: 0,
  maxWidth: '100%',
  px: { xs: 1, sm: 2, md: 3 },
  boxSizing: 'border-box' as const,
} as const;

/**
 * Contenedor con padding lateral seguro en móvil y ancho acotado (evita overflow con flex).
 */
export default function PageContainer(props: ContainerProps) {
  const { sx, ...rest } = props;
  return <Container {...rest} maxWidth={props.maxWidth ?? 'lg'} sx={{ ...pageSx, ...sx }} />;
}

export { pageSx };
